import React, {useState, useMemo} from "react";
import {Link} from "react-router-dom";
import {Welcomecard} from "../components/OnboardingCards/Welcomecard";
import {OnboardingCard} from "../components/OnboardingCards/OnboardingCard";
import {PreviewScreen} from "../components/LoadingSceen/LoadingScreen";
import {useImagePreloader} from "../Hooks/useImagePreloader";
import UserStore from "../store/user-store";
import { starknetIcon } from "../components/Icons/svg/paymnetSvgs";

const Onboardingpage = ({setOnboarding}) => {
    const hapticFeedBack = () => {
        window.Telegram.WebApp.HapticFeedback.notificationOccurred("success");
    };
    const lang = UserStore.langCode
    const clickHanlder = () => {
        localStorage.setItem("onboarding", "true")
        setOnboarding(true)
    }

    const path = "/images/onboarding_icons/"
    const onboarding_cards = useMemo(() => [
        {
            img_scr: path + (lang === "ru" ? "vpn_ru.png" : "vpn_en.png"),
            h1_text: lang === "ru" ? "Приватность прежде всего — VPN для Starknet" : "Privacy-first VPN for Starknet natives",
            p_text: lang === "ru" ? "" : "Harden your connection for dApps, and exchanges—from any location. 30+ locations and 100+ servers for global access",
            svg: null
        },
        {
            img_scr: path + (lang === "ru" ? "payments_ru.png" : "payments_en.png"),
            h1_text: lang === 'ru' ? "Удобная оплата" : "Pay Your Way",
            p_text: lang === "ru" ? "Множество платежных методов, оплачивайте подписку картой или криптой." : "Cards or crypto—your choice. Instant activation. No long forms, no friction.",
            svg: null
        },
        {
            img_scr: path + "starknet_blockchain.png",
            h1_text: lang === 'ru' ? "Ваша подписка, Starknet" : "Your subscription, Starknet",
            svg: starknetIcon,
            p_text: lang === "ru" ? "Множество платежных методов, оплачивайте подписку картой или криптой." : "We keep a minimal on-chain record of your status—no personal details. Move your sub from Telegram to the web app with a one-time code in ~10 seconds."
        },

    ], [lang]);
    const [cardindex, setIndex] = useState(0);

    // Собираем все URL изображений для предзагрузки
    const imageUrls = useMemo(() => {
        return onboarding_cards.map(card => card.img_scr);
    }, [lang]);

    // Предзагружаем изображения
    const { isLoading } = useImagePreloader(imageUrls);

    // Показываем экран загрузки пока изображения грузятся
    if (isLoading) {
        return <PreviewScreen />;
    }

    return (
        <div className="container">
            <div className="onboarding">
                <div className="onboarding__main_content">
                    {cardindex === 0 ? (
                        <Welcomecard/>
                    ) : onboarding_cards.map((card, index) =>
                            <OnboardingCard
                                key={index}
                                index={index + 1}
                                cardIndex={cardindex}
                                img_scr={card.img_scr}
                                h1_text={card.h1_text}
                                p_text={card.p_text}
                                svg={card?.svg}
                            />
                    )}

                </div>
                <div className="onboarding_footer">
                    {cardindex <= 2 ? (
                        <button
                            onClick={() => {
                                setIndex(cardindex + 1);
                                hapticFeedBack();
                            }}
                            className="onboarding__btn"
                        >
                            <p className="onboarding__btn__text">
                                {cardindex === 0 ? (lang === "ru" ? "Начать" : "Start") : (lang === "ru" ? "Далее" : "Next")}
                            </p>
                            <p className="onboarding__btn__counter">
                                {cardindex === 0 ? "" : `${cardindex}/3`}
                            </p>
                        </button>
                    ) : <Link className="onboarding__btn" to='/' onClick={clickHanlder}>
                        <p className="onboarding__btn__text">
                            {lang === "ru" ? "Поехали" : "Lets go"}
                        </p>
                        <p className="onboarding__btn__counter">
                            {cardindex === 0 ? "" : `${cardindex}/3`}
                        </p>
                    </Link>

                    }
                </div>
            </div>
        </div>
    )
        ;
};

export default Onboardingpage;
